import Collections from "Components/Collections";

const Parsers = () => {
  return (
    <Collections>
      <h1>Parsers</h1>
    </Collections>
  );
};

export default Parsers;